import { IconSearch } from "@tabler/icons-react";
import { BotonExportarExcel, Group, Input, Select, TablaSkeleton, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { TipoDocumentoAdmin } from "../services/tipos-documento-service";
import { resumenSobrescrituras } from "./TipoDocumentoRow";
import { TipoDocumentoRow } from "./TipoDocumentoRow";

/**
 * Tabla del catálogo de tipos de documento (54+ filas) · la búsqueda se
 * aplica en el SERVIDOR (el container la pasa como query param con debounce)
 * y acá solo se pinta la página visible. Cada fila controla su modo edición.
 */
export function TiposDocumentoTable({
  cargando = false,
  tipos,
  busqueda,
  onBusquedaChange,
  categorias,
  categoria,
  onCategoriaChange,
  sinResultados,
  hayBusqueda,
  obtenerFilas,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  tipos: TipoDocumentoAdmin[];
  busqueda: string;
  onBusquedaChange: (b: string) => void;
  categorias: { codigo: string; nombre: string }[];
  categoria: string;
  onCategoriaChange: (c: string) => void;
  sinResultados: boolean;
  hayBusqueda: boolean;
  /** Trae TODAS las páginas con la búsqueda actual · para el export. */
  obtenerFilas: () => Promise<TipoDocumentoAdmin[]>;
}) {
  return (
    <div>
      <Group justify="space-between" className="mb-2" align="flex-start">
        <Input
          placeholder="Buscar tipo…"
          leftSection={<IconSearch size={14} stroke={1.7} />}
          value={busqueda}
          onChange={(e) => onBusquedaChange(e.currentTarget.value)}
          wrapperClassName="max-w-90 flex-1"
        />
        <Select
          options={[{ value: "__todas__", label: "Todas las categorías" }, ...categorias.map((c) => ({ value: c.codigo, label: c.nombre }))]}
          value={categoria || "__todas__"}
          onValueChange={(v) => onCategoriaChange(v === "__todas__" ? "" : v)}
          className="w-60"
        />
        <BotonExportarExcel
          archivo="tipos-documento"
          hoja="Tipos de documento"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Categoría", value: (t) => t.categoriaNombre },
            { header: "Nombre", value: (t) => t.nombre },
            { header: "Configuración", value: (t) => resumenSobrescrituras(t.sobrescrituras) },
            { header: "Orden", value: (t) => t.orden },
            { header: "Estado", value: (t) => (t.activo ? "Activo" : "Inactivo") },
          ]}
        />
      </Group>
      <div className="overflow-x-auto">
        <Table verticalSpacing="sm">
          <Thead>
            <Tr>
              <Th>Categoría</Th>
              <Th>Nombre · configuración</Th>
              <Th>Estado</Th>
              <Th />
            </Tr>
          </Thead>
          {cargando ? (
            <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, { align: "right" }]} filas={15} />
          ) : (
            <Tbody>
              {tipos.map((t) => (
                <TipoDocumentoRow key={t.id} tipo={t} />
              ))}
              {sinResultados && (
                <Tr>
                  <Td colSpan={4}>
                    <Text size="sm" c="dimmed" ta="center" className="py-3">
                      {hayBusqueda ? "Sin resultados para la búsqueda." : 'Sin tipos. Crea el primero con "Nuevo tipo".'}
                    </Text>
                  </Td>
                </Tr>
              )}
            </Tbody>
          )}
        </Table>
      </div>
    </div>
  );
}
